import { render, staticRenderFns } from "./CcError.ts.vue?vue&type=template&id=4fea6c26"
import script from "./CcError.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CcError.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CcError.ts.vue?vue&type=style&index=0&id=4fea6c26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports